import { Button, FC, useEffect, useSearchParams} from 'external/react'
import Icon from 'external/fortawesome'
import { isEmpty } from 'utilities/text'

import { paymentService } from 'services/payment.service'

const SuccessPage: FC = () => {

	const [params] = useSearchParams()

	const getSessionRetriveById = async (session_id) => {
		const response = await paymentService.getSessionRetriveById(session_id);
		if (response.data.data.payment_status === 'paid') {
			localStorage.removeItem('packages');
		}
	};

	useEffect(() => {
		const session_id = params.get('session_id')
		if (!isEmpty(session_id)) {
			getSessionRetriveById(session_id)
		}
	}, [params]);

	return (
		<div style={{ textAlign: 'center', display: 'flex', height: '100vh' }}>
			<div className='card' style={{ margin: 'auto' }}>
				<div className='card-body'>
					<span style={{ fontSize: '80px' }}>
						<Icon name='faHandshake' />
					</span>
					<h5 className='card-title' style={{ fontSize: '30px' }}>
						¡Compra finalizada!
					</h5>
					<p className='card-text mt-3 mb-4' style={{ fontSize: '15px' }}>
						Gracias por realizar el pago, puede terminar de configurar el <br />
						paquete adquirido.
					</p>
					<div className='d-flex justify-content-between'>
						<Button variant='primary' className='w-100' href='/home/packages'>
							Ir a mis paquetes
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}

export {SuccessPage as default}